var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-layout md-alignment-center spinner-overlay",style:({'background-color': _vm.background, opacity: _vm.opacity})},[(!_vm.custom)?_c('md-progress-spinner',{attrs:{"md-diameter":_vm.diameter,"md-stroke":_vm.stroke,"md-mode":"indeterminate"}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }